export default {
  install(Vue) {
      Vue.prototype.$defaultApplicationParams = {
        package_name: '',
        profile_id: null,
        status: 'active',
        perPage: 20, // передаем только число
        page: 1,
        sort: 'updated_at',
        sort_direction: 'DESC'
      };
  }
};
